<YCPage query={pageQuery}>
  <div class="page-content">
    <form on:submit={handleSubmit}>
      <input class="login-box" name="email" type="email" placeholder="Enter your email" bind:value={email} bind:this={emailInput} required />

      <div class="checkbox-row">
        <input type="checkbox" id="terms-checkbox" name="terms" bind:checked={emailOptIn} />
        <label for="terms-checkbox">Be the first to know about Leeds United news & services, ticketing updates, retail offers, events, hospitality, messages from club partners & the Leeds United Foundation.</label>
      </div>

      <button class="submit-button" type="submit" disabled={!isFormValid}>
        SUBMIT
      </button>
    </form>
  </div>
  <InstructionsPopup
    bind:opened={instructionsPopupOpen}
    title="How to Sign-In"
    steps={instructionSteps}
    onClose={handleInstructionsPopupClose}
  />
</YCPage>

<style>.page-content {
  width: 100%;
  min-height: 100vh;
  position: relative;
  background:
      linear-gradient(to bottom, transparent 180vw, black 225vw),
      url('../static/images/leeds.jpg') top / 100% auto no-repeat;
  background-color: black;
}

.login-box {
  display: block;
  position: absolute;
  top: 104vw;
  left: 22vw;
  font-size: 4.5vw;
  color: black;
  width: 55vw;
}

.checkbox-row {
  display: flex;
  align-items: flex-start;
  position: absolute;
  top: 116vw;
  left: 11vw;
  width: 78vw;
  grid-gap: 4vw;
  gap: 4vw;
}

.checkbox-row input[type="checkbox"] {
  flex-shrink: 0;
  width: 5vw;
  height: 5vw;
  margin: 0;
}

.checkbox-row label {
  font-size: 3vw;
  color: white;
  line-height: 1.15;
}

.submit-button {
  display: block;
  position: absolute;
  top: 136vw;
  left: 10vw;
  width: auto;
  border: none;
  padding: 2vw 6vw;
  font-size: 4vw;
  font-weight: bold;
  border-radius: 35px;
  background-color: #FFCC00;
  color: #0F1743;
  cursor: pointer;
}

.submit-button:disabled {
  background: #979797;
  color: #CFCFCF;
  cursor: not-allowed;
}

.submit-button svg {
  width: 100%;
  height: 100%;
}</style>


<script lang='ts'>var _a;
import YCPage from '../components/YCPage.svelte';
import { f7 } from 'framework7-svelte';
import { getToken } from 'inversify-token';
import ROOT from '../inversify.config';
import { JanusSignonManagerToken } from '../js/sso';
import InstructionsPopup from '../components/InstructionsPopup.svelte';
export let f7route;
const instructionSteps = [
    {
        title: 'Check your Email',
        description: 'Keep this page open and switch to your email client. Watch for the email with the sign-in link. If you don\'t see the email, check your spam folder or request a new link below.'
    },
    {
        title: 'Tap the Link in the Email',
        description: 'When you receive the email, tap the link to sign in. You must complete this step to access the drop.'
    },
    {
        title: 'Return to this Page',
        description: 'Switch back to this page and you will be automatically logged in and taken to the drop.'
    },
    {
        title: 'Enter the Drop',
        description: 'Stay in the drop until the end for a chance to win the prize!'
    }
];
const pageQuery = f7route.query;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
let state = 'ENTER_EMAIL'; // ENTER_EMAIL | VERIFY_EMAIL | LOGGED_IN
let instructionsPopupOpen = false;
let email = '';
let emailInput;
let isFormValid = false;
let emailOptIn = false;
$: email, isFormValid = (_a = emailInput === null || emailInput === void 0 ? void 0 : emailInput.validity.valid) !== null && _a !== void 0 ? _a : false;
function handleInstructionsPopupClose() {
    state = 'ENTER_EMAIL';
    instructionsPopupOpen = false;
}
async function handleSubmit(event) {
    event.preventDefault();
    if (state !== 'ENTER_EMAIL') {
        return;
    }
    f7.preloader.show();
    try {
        const formData = new FormData(event.target);
        const email = formData.get('email');
        console.log('Submitting email for verification...', email);
        const isAvailable = await signonManager.checkEmailAvailability(email);
        if (!isAvailable.success) {
            console.error('Error checking email availability:', isAvailable.errorMessage);
            alert('An error occurred while checking your email. Please try again later.');
            return;
        }
        const otp = signonManager.generatePKCECodeVerifier();
        if (isAvailable.data) {
            console.log('Email is not registered');
            const registerResult = await signonManager.registerWithYinzCamEmailPasswordWithOtp(email, '', otp, {}, { EmailTemplateSlug: 'everything-leeds-drops' }); // user will have to reset pw later
            if (registerResult.errorCode !== 'EMAIL_VERIFICATION') {
                console.error('Error registering email (expected EMAIL_VERIFICATION error):', registerResult);
                alert('An error occurred during sign-up. Please try again later.');
                return;
            }
        }
        else {
            console.log('Email is registered, sending password reset email');
            const loginResult = await signonManager.loginWithYinzCamPasswordless(email, otp, { EmailTemplateSlug: 'everything-leeds-drops' });
            if (!loginResult.success) {
                console.error('Error requesting passwordless login:', loginResult);
                alert('An error occurred during sign-in. Please try again later.');
                return;
            }
        }
        state = 'VERIFY_EMAIL';
        instructionsPopupOpen = true;
        const delayedPasswordlessCheck = () => {
            if (state !== 'VERIFY_EMAIL')
                return;
            setTimeout(async () => {
                if (state !== 'VERIFY_EMAIL')
                    return;
                const rsp = await signonManager.pollPasswordlessStatus(otp);
                if (state !== 'VERIFY_EMAIL')
                    return;
                console.log('Passwordless status response:', rsp);
                if (rsp.data.PasswordlessTokenStatus === 'VERIFIED') {
                    state = 'LOGGED_IN';
                    setTimeout(async () => {
                        await signonManager.updateUserProfileSegment({ email_optin: (emailOptIn) ? 'true' : 'false' });
                        instructionsPopupOpen = false;
                        setTimeout(() => f7.views.main.router.navigate(pageQuery.redirectTo || '/'), 500);
                    }, 0);
                    return;
                }
                delayedPasswordlessCheck();
            }, 3000);
        };
        delayedPasswordlessCheck();
    }
    catch (error) {
        console.error('Error during sign-in process:', error);
        alert('An unexpected error occurred. Please try again later.');
    }
    finally {
        f7.preloader.hide();
    }
}
</script>
